// Pure season-aggregation helpers for SeasonsEditor (extracted from
// components/SeasonsEditor.jsx). No React/JSX — grouping + per-column sums.
import { computePwhlDerived } from "./pwhlStatColumns";

export function groupBySeasonOrdered(rows) {
    // Preserve insertion order of seasons. Rows with empty season form one group at the end.
    const order = [];
    const map = new Map();
    rows.forEach((r, idx) => {
        const s = r.season || "";
        if (!map.has(s)) {
            map.set(s, { season: s, indices: [] });
            order.push(s);
        }
        map.get(s).indices.push(idx);
    });
    return order.map((s) => map.get(s));
}

export function sumSkater(group, rows) {
    return group.indices.reduce(
        (acc, i) => {
            const r = rows[i];
            return {
                gp: acc.gp + Number(r.gp || 0),
                g: acc.g + Number(r.g || 0),
                a: acc.a + Number(r.a || 0),
                p: acc.p + Number(r.p || 0),
                pim: acc.pim + Number(r.pim || 0),
                plus_minus: acc.plus_minus + Number(r.plus_minus || 0),
                po_gp: acc.po_gp + Number(r.po_gp || 0),
                po_g: acc.po_g + Number(r.po_g || 0),
                po_a: acc.po_a + Number(r.po_a || 0),
                po_p: acc.po_p + Number(r.po_p || 0),
                po_pim: acc.po_pim + Number(r.po_pim || 0),
                po_plus_minus: acc.po_plus_minus + Number(r.po_plus_minus || 0),
            };
        },
        { gp: 0, g: 0, a: 0, p: 0, pim: 0, plus_minus: 0,
          po_gp: 0, po_g: 0, po_a: 0, po_p: 0, po_pim: 0, po_plus_minus: 0 }
    );
}

export function sumGoalie(group, rows) {
    let gp = 0, w = 0, l = 0, t = 0, otl = 0, so = 0;
    let gaaSum = 0, svSum = 0, gpTotal = 0;
    let po_gp = 0, po_w = 0, po_l = 0, po_t = 0, po_otl = 0, po_so = 0;
    let poGaaSum = 0, poSvSum = 0, poGpTotal = 0;
    group.indices.forEach((i) => {
        const r = rows[i];
        const rg = Number(r.gp || 0);
        gp += rg; w += Number(r.w || 0); l += Number(r.l || 0); t += Number(r.t || 0); otl += Number(r.otl || 0); so += Number(r.so || 0);
        gaaSum += Number(r.gaa || 0) * rg; svSum += Number(r.sv_pct || 0) * rg; gpTotal += rg;
        const prg = Number(r.po_gp || 0);
        po_gp += prg; po_w += Number(r.po_w || 0); po_l += Number(r.po_l || 0); po_t += Number(r.po_t || 0); po_otl += Number(r.po_otl || 0); po_so += Number(r.po_so || 0);
        poGaaSum += Number(r.po_gaa || 0) * prg; poSvSum += Number(r.po_sv_pct || 0) * prg; poGpTotal += prg;
    });
    return {
        gp, w, l, t, otl, so,
        gaa: gpTotal ? gaaSum / gpTotal : 0,
        sv_pct: gpTotal ? svSum / gpTotal : 0,
        po_gp, po_w, po_l, po_t, po_otl, po_so,
        po_gaa: poGpTotal ? poGaaSum / poGpTotal : 0,
        po_sv_pct: poGpTotal ? poSvSum / poGpTotal : 0,
    };
}

// Generic per-column totals for an arbitrary column set (used by the PWHL
// full-stat editor). Derived columns are computed from the summed components.
// TOI is a text MM:SS field — summed in seconds and re-formatted (never 0).
export function sumByCols(group, rows, cols, isGoalie) {
    const totals = {};
    cols.forEach((c) => { if (!c.derived && !c.text) totals[c.key] = 0; });
    let toiSec = 0;
    let hasToi = false;
    group.indices.forEach((i) => {
        const r = rows[i];
        cols.forEach((c) => { if (!c.derived && !c.text) totals[c.key] += Number(r[c.key] || 0); });
        const sec = _toiToSeconds(r.toi);
        if (sec > 0) { toiSec += sec; hasToi = true; }
    });
    if (cols.some((c) => c.key === "toi")) totals.toi = hasToi ? _secToToi(toiSec) : "";
    return { ...totals, ...computePwhlDerived(totals, isGoalie) };
}

function _toiToSeconds(v) {
    if (v == null || v === "") return 0;
    const s = String(v).trim();
    if (s.includes(":")) {
        const [m, sec] = s.split(":");
        return (Number(m) || 0) * 60 + (Number(sec) || 0);
    }
    return Math.round((Number(s) || 0) * 60); // bare minutes
}
function _secToToi(total) {
    if (!total) return "";
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${m}:${String(s).padStart(2, "0")}`;
}
